import { render, staticRenderFns } from "./Area11.vue?vue&type=template&id=01cbedc2&scoped=true&"
import script from "./Area11.vue?vue&type=script&lang=js&"
export * from "./Area11.vue?vue&type=script&lang=js&"
import style0 from "./Area11.vue?vue&type=style&index=0&id=01cbedc2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cbedc2",
  null
  
)

export default component.exports